import styled from 'styled-components';

export const StatusIconWrap = styled.div(
  props => `
    width: 5.4rem;
    height: 5.4rem;
    background-color: ${props.theme.colors.white.base};
    display: flex;
    position: absolute;
    left: -2.7rem;
    top: 2rem;
    `
    );
    
export const StatusIconPaddingWrap = styled(StatusIconWrap)(
  props => `
    border-radius: ${props.theme.misc.borderRadius.round};
    border: solid 3px #f1f1f1;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l12};
  `
)
